<script>
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    const dispatch = createEventDispatcher();
    const submit = () => dispatch('submit');
	export let below;
    export let text;
    export let shownote;
</script>
<div class="btn" on:click="{submit}">
    <slot></slot>
    {#if shownote}
        {#if below}
        <span class="note" transition:fade="{{duration: 100 }}">
            {text}
        </span>
        {:else}
        <span class="note2" transition:fade="{{duration: 100 }}">
            {text}
        </span>
        {/if}
    {/if}
</div>
<style>
    .btn{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .note {
        width: 3rem;
        height: 1.2rem;
        border: .08rem solid #000;
        background-color: #000;
        position: absolute;
        bottom: -100%;
        left: calc(50% - 1.5rem);
        border-radius: .2rem;
        color: #aaa;
        font-size: .76rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        z-index: 9;
    }
    .note:after,
    .note:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: .3rem solid transparent;
        border-bottom-color: #000;
        left: 50%;
        margin-left: -.3rem;
        top: -.6rem;
    }
    .note:after {
        border-bottom-color: #000;
        top: -.5rem;
    }
    .note2 {
        width: 3rem;
        height: 1.2rem;
        border: .08rem solid #000;
        background-color: #000;
        position: absolute;
        top: -100%;
        left: calc(50% - 1.5rem);
        border-radius: .2rem;
        color: #aaa;
        font-size: .76rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        z-index: 9;
    }
    .note2:after,
    .note2:before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: .3rem solid transparent;
        border-top-color: #000;
        left: 50%;
        margin-left: -.3rem;
        bottom: -.65rem;
    }
    .note2:after {
        border-top-color: #000;
        bottom: -.55rem;
    }
</style>